import { isRepaymentSettled, repaymentStatusLabel, getRepaymentStatus } from "../utils/repaymentStatus";
import { Space, Table, Tag } from "antd";
import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { format } from "date-fns";

const formatDate = (dateString) => {
  if (!dateString) return "-"; // Return a default value if the date string is not provided

  const date = new Date(dateString); // Create a Date object from the date string
  const formattedDate = format(date, "MMMM dd, yyyy"); // Use date-fns to format the date in the desired format

  return formattedDate;
};

const TableRepaymentLender = ({
  dataRepaymentSchedule,
  onRowClick,
  className = "",
}) => {
  const processedData = dataRepaymentSchedule.map((item, index) => ({
    key: index + 1,
    ...item,
  }));

  const [screenWidth, setScreenWidth] = useState(1920);
  const [isMobile, setIsMobile] = useState(
    Cookies.get("ismobile") === "yes" ? true : false
  );
  useEffect(() => {
    if (screenWidth < 1200) {
      Cookies.set("ismobile", "yes");
      setIsMobile(true);
    } else {
      Cookies.set("ismobile", "no");
      setIsMobile(false);
    }
  }, [screenWidth]);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Call handleResize initially to set the initial screen width
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const columns = [
    {
      title: (
        <span
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: "600",
            fontSize: "15px",
            color: "grey",
          }}
        >
          No.
        </span>
      ),
      dataIndex: "key",
      rowScope: "row",
      align: "center",
      width: 64,
      render: (text) => <span className="sl-repayment-index">{text}</span>,
    },
    {
      title: (
        <span
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: "600",
            fontSize: "15px",
            color: "grey",
          }}
        >
          Monthly Installment
        </span>
      ),
      dataIndex: "repay_amount",
      key: "repay_amount",
      width: 178,
      render: (text) => (
        <span
          className="sl-repayment-amount"
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: "400",
            fontSize: "12px",
            opacity: ".6",
          }}
        >{`${
          text
            ? text.toLocaleString("en-US", {
                style: "currency",
                currency: "SGD",
              })
            : "-"
        }`}</span>
      ),
    },
    {
      title: (
        <span
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: "600",
            fontSize: "15px",
            color: "grey",
          }}
        >
          Loan Balance
        </span>
      ),
      dataIndex: "loan_balance",
      key: "loan_balance",
      width: 176,
      render: (text, record) => (
        <span
          className="sl-repayment-balance"
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: "400",
            fontSize: "12px",
            opacity: ".6",
          }}
        >
          {!isRepaymentSettled(record)
            ? "-"
            : `${
                text
                  ? text.toLocaleString("en-US", {
                      style: "currency",
                      currency: "SGD",
                    })
                  : "-"
              }`}
        </span>
      ),
    },
    {
      title: (
        <span
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: "600",
            fontSize: "15px",
            color: "grey",
          }}
        >
          Late Day
        </span>
      ),
      dataIndex: "late_day",
      key: "late_day",
      width: 116,
      render: (text, record) => (
        <span
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: "400",
            fontSize: "12px",
            opacity: ".6",
          }}
        >
          {getRepaymentStatus(record) === "assumed_paid" ? "0 Day" : text === null ? "-" : `${text + " Day" || "0"}`}
        </span>
      ),
    },
    {
      title: (
        <span
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: "600",
            fontSize: "15px",
            color: "grey",
          }}
        >
          Repayment Date
        </span>
      ),
      dataIndex: "repay_date",
      key: "repay_date",
      width: 184,
      render: (text) => (
        <span
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: "400",
            fontSize: "12px",
            opacity: ".6",
          }}
        >{`${text ? formatDate(text) : "-"}`}</span>
      ),
    },
    {
      title: (
        <span
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: "600",
            fontSize: "15px",
            color: "grey",
          }}
        >
          Repayment Due Date
        </span>
      ),
      dataIndex: "repay_due_date",
      key: "repay_due_date",
      width: 176,
      render: (text) => (
        <span
          className="sl-repayment-date-pill"
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: "400",
            fontSize: "12px",
            opacity: ".6",
          }}
        >{`${text ? formatDate(text) : "-"}`}</span>
      ),
    },
    {
      title: (
        <span
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: "600",
            fontSize: "15px",
            color: "grey",
          }}
        >
          Status
        </span>
      ),
      dataIndex: "status",
      key: "status",
      width: 112,
      render: (text, record) => (
        <span
          className={`sl-repayment-status sl-repayment-status-${String(
            getRepaymentStatus(record)
          ).toLowerCase()}`}
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: "400",
            fontSize: "12px",
            opacity: ".6",
          }}
        >{repaymentStatusLabel(record)}</span>
      ),
    },
  ];
  const columnsMobile = [
    {
      title: (
        <span
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: "600",
            fontSize: "15px",
            color: "grey",
          }}
        >
          No.
        </span>
      ),
      dataIndex: "key",
      rowScope: "row",
      align: "center",
      width: 58,
      render: (text) => <span className="sl-repayment-index">{text}</span>,
    },
    {
      title: (
        <span
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: "600",
            fontSize: "15px",
            color: "grey",
          }}
        >
          Monthly Installment
        </span>
      ),
      dataIndex: "repay_amount",
      key: "repay_amount",
      width: 160,
      render: (text) => (
        <span
          className="sl-repayment-amount"
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: "400",
            fontSize: "12px",
            opacity: ".6",
          }}
        >{`${
          text
            ? text.toLocaleString("en-US", {
                style: "currency",
                currency: "SGD",
              })
            : "-"
        }`}</span>
      ),
    },
    {
      title: (
        <span
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: "600",
            fontSize: "15px",
            color: "grey",
          }}
        >
          Repayment Due Date
        </span>
      ),
      dataIndex: "repay_due_date",
      key: "repay_due_date",
      width: 168,
      render: (text) => (
        <span
          className="sl-repayment-date-pill"
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: "400",
            fontSize: "12px",
            opacity: ".6",
          }}
        >{`${text ? formatDate(text) : "-"}`}</span>
      ),
    },
    {
      title: (
        <span
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: "600",
            fontSize: "15px",
            color: "grey",
          }}
        >
          Status
        </span>
      ),
      dataIndex: "status",
      key: "status",
      width: 104,
      render: (text, record) => (
        <span
          className={`sl-repayment-status sl-repayment-status-${String(
            getRepaymentStatus(record)
          ).toLowerCase()}`}
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: "400",
            fontSize: "12px",
            opacity: ".6",
          }}
        >{repaymentStatusLabel(record)}</span>
      ),
    },
  ];

  return (
    <Table
      className={`sl-repayment-table ${className}`}
      columns={isMobile ? columnsMobile : columns}
      dataSource={processedData}
      pagination={false}
      tableLayout="fixed"
      scroll={{ x: isMobile ? 490 : 1006 }}
      style={{ borderRadius: "10px 10px 10px 10px" }}
      rowClassName={(record) =>
        `sl-repayment-row sl-repayment-row-${String(
          record.status || "unknown"
        ).toLowerCase()}`
      }
      bordered={false}
    />
  );
};

export default TableRepaymentLender;
